import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ModalService } from '@atsystems/ui';
import { PomodoroTimerService } from 'src/app/common/services/pomodoro-timer.service';
import { PomodoroSettingsModalComponent } from './components/pomodoro-settings-modal/pomodoro-settings-modal.component';

const PHASE_LABELS: Record<string, string> = {
  'Work': 'Focus session',
  'Short-break': 'Short break',
  'Long-break': 'Long break',
};

@Component({
  selector: 'ats-pomodoro-timer',
  imports: [CommonModule],
  templateUrl: './pomodoro-timer.component.html',
  styleUrl: './pomodoro-timer.component.sass',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PomodoroTimerComponent {
  private pomodoroTimerService = inject(PomodoroTimerService);
  private modalService = inject(ModalService);

  public isActive = this.pomodoroTimerService.isActive;
  public isPaused = this.pomodoroTimerService.isPaused;
  public currentDuration = this.pomodoroTimerService.currentDuration;
  public remainingTime = this.pomodoroTimerService.remainingTime;
  public currentDurationType = this.pomodoroTimerService.currentDurationType;
  public currentIteration = this.pomodoroTimerService.currentIteration;
  public totalIterations = this.pomodoroTimerService.totalIterations;

  public phaseLabel = computed(() => PHASE_LABELS[this.currentDurationType()] ?? this.currentDurationType());

  public progress = computed(() => {
    const total = this.currentDuration() * 60 * 1000;
    if (!total || this.isPaused()) return 0;
    return Math.min(100, Math.max(0, ((total - this.remainingTime()) / total) * 100));
  });

  public toggleTimer() {
    this.pomodoroTimerService.toggleTimer();
  }

  public togglePause() {
    this.pomodoroTimerService.togglePause();
  }

  public openSettingsModal() {
    this.modalService.open(PomodoroSettingsModalComponent);
  }
}
